var ___EXPOSE_LOADER_IMPORT___ = require("-!./tippy.esm.js");
var ___EXPOSE_LOADER_GET_GLOBAL_THIS___ = require("../../../../expose-loader@1.0.3_webpack@5.75.0/node_modules/expose-loader/dist/runtime/getGlobalThis.js");
var ___EXPOSE_LOADER_GLOBAL_THIS___ = ___EXPOSE_LOADER_GET_GLOBAL_THIS___;
___EXPOSE_LOADER_GLOBAL_THIS___["tippy"] = ___EXPOSE_LOADER_IMPORT___;
module.exports = ___EXPOSE_LOADER_IMPORT___;
